import {apiAxios, baseUrl, DeviceId} from "@/service/ApiClient";
import {BACKEND_ENDPOINTS} from "@/service/backendEndPoints";

export default class api {
    public static go(name: string, data: any = {}) {
        DeviceId().then(resp => {
            apiAxios.defaults.headers.common['LF-Device'] = resp
        })
        if (BACKEND_ENDPOINTS[name] !== undefined) {
            const options = BACKEND_ENDPOINTS[name]
            const baseU = baseUrl()
            return apiAxios({
                baseURL: baseU,
                method: options.method,
                url: this.formatUrl(options.url, data.params || {}),
                data: data.body || {},
                params: data.query || {}
            })
        } else {
            return apiAxios(data)
        }
    }

    private static formatUrl(url: string, arg: any) {
        if (Object.keys(arg).length !== 0) {
            let str = url
            for (let value in arg) {
                str = str.replace(`{${value}}`, arg[value])
                // console.log(str)
            }
            return str
        }
        return url
    }
}
